<div class="clinics-container">
    <mat-card class="cardWithShadow">
        <mat-card-header>
            <div style="display: flex; justify-content: space-between; width: 100%;">
                <div>
                    <mat-card-title> {{ 'TOTAL_CLINICS' | translate }} ({{ clinics?.length || 0
                        }})</mat-card-title>
                    <span class="subtitle">{{ "CLINICS_REGISTERED_ACCOUNT" | translate }}</span>
                </div>

                <div style="display: flex; gap: 15px; align-items: center;">
                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                        <input matInput (keyup)="applyFilter($event)" placeholder="{{ 'SearchHere' | translate }}"
                            #input />
                    </mat-form-field>
                    <button class="m-l-15" mat-mini-fab color="primary" matTooltip="{{ 'ADD' | translate}}"
                        (click)="openCreateClinicModal()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>

        </mat-card-header>
        <mat-card-content class="p-24">
            <div class="table-responsive">
                <table mat-table
                    [dataSource]="filteredClinics.slice(currentPage * pageSize, (currentPage + 1) * pageSize)"
                    class="w-100">

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">{{ 'NAME' | translate }}</th>
                        <td mat-cell *matCellDef="let clinic">
                            <div style="display: flex; gap: 5px;">
                                <span>{{ clinic.name }}</span>
                                <span *ngIf="clinic.default" class="default-clinic-icon" matTooltip="Default Clinic">
                                    <i-tabler name="home" style="width: 18px; height: 18px;"></i-tabler>
                                </span>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="billing">
                        <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                            {{ 'BILLING' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let clinic" class="f-s-14">
                            <div class="box-information">
                                <span><strong>{{clinic.billingAddress.contactNameAndSurname}}</strong></span>
                                <span>{{clinic.billingAddress.phoneNumber}}</span>
                                <span>{{clinic.billingAddress.streetNameAndNumber}}</span>
                                <span>{{clinic.billingAddress.city}}</span>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="shipping">
                        <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                            {{ 'SHIPPING' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let clinic" class="f-s-14">
                            <div class="box-information">
                                <span><strong>{{clinic.shippingAddress.contactNameAndSurname}}</strong></span>
                                <span>{{clinic.shippingAddress.phoneNumber}}</span>
                                <span>{{clinic.shippingAddress.streetNameAndNumber}}</span>
                                <span>{{clinic.shippingAddress.city}}</span>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let clinic; columns: displayedColumns" class="hoverable-row"
                        (click)="openClinicDetails(clinic)"></tr>
                </table>
                <div class="loading" *ngIf="isLoading">
                    <ngx-skeleton-loader [count]="10" [theme]="{ 'border-radius': '0', height: '50px' }"
                        [appearance]="'line'">
                    </ngx-skeleton-loader>
                </div>
                <mat-paginator [pageSizeOptions]="[5,10]" [length]="clinics?.length" [pageSize]="pageSize"
                    (page)="onPageChange($event)" showFirstLastButtons></mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>
</div>

<div class="loading" *ngIf="isLoading">
    <ngx-skeleton-loader [count]="10" [theme]="{ 'border-radius': '0', height: '50px' }" [appearance]="'line'">
    </ngx-skeleton-loader>
</div>

<p-dialog header="{{ 'NEW_CLINIC' | translate }}" [(visible)]="createClinicFormVisible" [style]="{width: '50vw'}"
    [modal]="true" [baseZIndex]="10000" [draggable]="false" [modal]="true">
    <form class="form-horizontal b-form" [formGroup]="createClinicForm">
        <div class="col-12">
            <div class="custom-box">
                <div style="display:flex; justify-content: space-between;" class="p-3">
                    <h3 class="modal-title">{{ 'CLINIC_INFORMATION' | translate }}</h3>
                </div>

                <div class="form-group">
                    <div class="input-box">
                        <span>{{ 'CLINIC_NAME' | translate }} *</span>
                        <input type="text" class="form-control" formControlName="name" id="name" />
                    </div>
                </div>

                <div formGroupName="shippingAddress">
                    <h4 class="mt-4">{{ 'SHIPPING_ADDRESS' | translate }}</h4>
                    <div class="form-group">
                        <div class="input-box">
                            <span>{{ 'CONTACT_NAME' | translate }} *</span>
                            <input type="text" formControlName="contactNameAndSurname" class="form-control"
                                id="shippingContactNameAndSurname" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'COUNTRY' | translate }} *</span>
                            <input type="text" formControlName="country" class="form-control" id="shippingCountry" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'CITY' | translate }} *</span>
                            <input type="text" formControlName="city" class="form-control" id="shippingCity" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'PROVINCE' | translate }}</span>
                            <input type="text" formControlName="province" class="form-control" id="shippingProvince" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'STREET_NAME' | translate }}</span>
                            <input type="text" formControlName="streetNameAndNumber" class="form-control"
                                id="shippingStreetNameAndNumber" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'APARTMENT' | translate }}</span>
                            <input type="text" formControlName="apartmentOrOthers" class="form-control"
                                id="shippingApartmentOrOthers" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'POSTAL_CODE' | translate }}</span>
                            <input type="text" formControlName="postalCode" class="form-control"
                                id="shippingPostalCode" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'PHONE_NUMBER' | translate }}</span>
                            <input type="text" formControlName="phoneNumber" class="form-control"
                                id="shippingPhoneNumber" />
                        </div>
                    </div>
                </div>

                <div formGroupName="billingAddress">
                    <h4 class="mt-4">{{ 'BILLING_ADDRESS' | translate }}</h4>
                    <div class="form-group">
                        <div class="input-box my-3" style="margin-bottom: 20px;">
                            <input class="mr-2" type="checkbox" id="sameAsShipping"
                                (change)="copyShippingAddress($event)" />
                            <label class="text-sm" for="sameAsShipping">{{ 'SAME_AS_SHIPPING_ADDRESS' | translate
                                }}</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="input-box">
                            <span>{{ 'CONTACT_NAME' | translate }}</span>
                            <input type="text" formControlName="contactNameAndSurname" class="form-control"
                                id="billingContactNameAndSurname" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'COUNTRY' | translate }}</span>
                            <input type="text" formControlName="country" class="form-control" id="billingCountry" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'CITY' | translate }}</span>
                            <input type="text" formControlName="city" class="form-control" id="billingCity" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'PROVINCE' | translate }}</span>
                            <input type="text" formControlName="province" class="form-control" id="billingProvince" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'STREET_NAME' | translate }}</span>
                            <input type="text" formControlName="streetNameAndNumber" class="form-control"
                                id="billingStreetNameAndNumber" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'APARTMENT' | translate }}</span>
                            <input type="text" formControlName="apartmentOrOthers" class="form-control"
                                id="billingApartmentOrOthers" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'POSTAL_CODE' | translate }}</span>
                            <input type="text" formControlName="postalCode" class="form-control"
                                id="billingPostalCode" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'PHONE_NUMBER' | translate }}</span>
                            <input type="text" formControlName="phoneNumber" class="form-control"
                                id="billingPhoneNumber" />
                        </div>
                    </div>
                </div>

                <div class="input-box-checkbox">
                    <label for="clinicDefault">{{ 'DEFAULT_CLINIC' | translate }}</label>
                    <input type="checkbox" id="clinicDefault" formControlName="default" name="default">
                </div>

                <div *ngIf="user && user.role === 'ROLE_DISTRIBUTOR_PROFESSIONAL' && user.edserWebhook"
                    formGroupName="connectedPlatform">
                    <h4 class="mt-4">{{ 'CONNECTED_PLATFORMS' | translate }}</h4>
                    <div class="form-group">
                        <span style="margin-bottom: 3px;"><strong>Edser</strong></span>
                        <div class="input-box mt-2" style="margin-top: 15px;">
                            <span>{{ 'IDENTIFIER' | translate }}</span>
                            <input type="text" formControlName="identifier" class="form-control"
                                id="connectedPlatformIdentifier" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'MULTIPLE_IDENTIFIER' | translate }}</span>
                            <ng-select [(ngModel)]="selectedIdentifiersList" [items]="selectedIdentifiersList"
                                placeholder="{{ 'ADD_IDENTIFIER' | translate }}" appendTo="body" multiple="true"
                                formControlName="identifiersList" [addTag]="true"
                                (clear)="updateNewClinicMultipleIdentifiers()"
                                (change)="updateNewClinicMultipleIdentifiers()">
                            </ng-select>
                        </div>
                    </div>
                </div>
                <div class="create-button-container">
                    <button mat-raised-button color="primary" [disabled]="!createClinicForm.valid"
                        (click)="createClinicInDB()">Create</button>
                </div>
            </div>
        </div>
    </form>
</p-dialog>

<p-dialog header="{{ selectedClinic.name }}" *ngIf="selectedClinic" [(visible)]="viewClinicDetails" [modal]="true"
    [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="false" [modal]="true">
    <form *ngIf="selectedClinic" class="form-horizontal b-form" [formGroup]="viewClinicForm">
        <div class="col-12">
            <div class="custom-box">
                <div style="display:flex; justify-content: space-between;" class="p-3">
                    <h3 class="modal-title">{{ 'CLINIC_INFORMATION' | translate }}</h3>
                </div>

                <div class="form-group">
                    <div class="input-box">
                        <span>{{ 'CLINIC_NAME' | translate }}</span>
                        <input type="text" class="form-control" formControlName="name" id="name" />
                    </div>
                </div>

                <div formGroupName="shippingAddress">
                    <h4 class="mt-4">{{ 'SHIPPING_ADDRESS' | translate }}</h4>
                    <div class="form-group">
                        <div class="input-box">
                            <span>{{ 'CONTACT_NAME' | translate }} *</span>
                            <input type="text" formControlName="contactNameAndSurname" class="form-control"
                                id="shippingContactNameAndSurname" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'COUNTRY' | translate }} *</span>
                            <input type="text" formControlName="country" class="form-control" id="shippingCountry" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'CITY' | translate }} *</span>
                            <input type="text" formControlName="city" class="form-control" id="shippingCity" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'PROVINCE' | translate }}</span>
                            <input type="text" formControlName="province" class="form-control" id="shippingProvince" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'STREET_NAME' | translate }}</span>
                            <input type="text" formControlName="streetNameAndNumber" class="form-control"
                                id="shippingStreetNameAndNumber" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'APARTMENT' | translate }}</span>
                            <input type="text" formControlName="apartmentOrOthers" class="form-control"
                                id="shippingApartmentOrOthers" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'POSTAL_CODE' | translate }}</span>
                            <input type="text" formControlName="postalCode" class="form-control"
                                id="shippingPostalCode" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'PHONE_NUMBER' | translate }}</span>
                            <input type="text" formControlName="phoneNumber" class="form-control"
                                id="shippingPhoneNumber" />
                        </div>
                    </div>
                </div>

                <div formGroupName="billingAddress">
                    <h4 class="mt-4">{{ 'BILLING_ADDRESS' | translate }}</h4>
                    <div class="form-group">
                        <div class="input-box">
                            <span>{{ 'CONTACT_NAME' | translate }}</span>
                            <input type="text" formControlName="contactNameAndSurname" class="form-control"
                                id="billingContactNameAndSurname" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'COUNTRY' | translate }}</span>
                            <input type="text" formControlName="country" class="form-control" id="billingCountry" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'CITY' | translate }}</span>
                            <input type="text" formControlName="city" class="form-control" id="billingCity" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'PROVINCE' | translate }}</span>
                            <input type="text" formControlName="province" class="form-control" id="billingProvince" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'STREET_NAME' | translate }}</span>
                            <input type="text" formControlName="streetNameAndNumber" class="form-control"
                                id="billingStreetNameAndNumber" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'APARTMENT' | translate }}</span>
                            <input type="text" formControlName="apartmentOrOthers" class="form-control"
                                id="billingApartmentOrOthers" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'POSTAL_CODE' | translate }}</span>
                            <input type="text" formControlName="postalCode" class="form-control"
                                id="billingPostalCode" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'PHONE_NUMBER' | translate }}</span>
                            <input type="text" formControlName="phoneNumber" class="form-control"
                                id="billingPhoneNumber" />
                        </div>
                    </div>
                </div>

                <div class="input-box-checkbox">
                    <label for="clinicDefault">{{ 'DEFAULT_CLINIC' | translate }}</label>
                    <input type="checkbox" id="clinicDefault" formControlName="default" name="default">
                </div>

                <div *ngIf="showConnectedPlatform" formGroupName="connectedPlatform">
                    <h4 class="mt-4">{{ 'CONNECTED_PLATFORMS' | translate }}</h4>
                    <div class="form-group">
                        <span class="mb-3">Edser</span>
                        <div class="input-box mt-2">
                            <span>{{ 'IDENTIFIER' | translate }}</span>
                            <input type="text" formControlName="identifier" class="form-control"
                                id="connectedPlatformIdentifier" />
                        </div>
                        <div class="input-box">
                            <span>{{ 'MULTIPLE_IDENTIFIER' | translate }}</span>
                            <ng-select [(ngModel)]="selectedClinic.connectedPlatform.identifiersList"
                                [items]="selectedClinic.connectedPlatform.identifiersList" bindLabel="name"
                                placeholder="{{ 'ADD_IDENTIFIER' | translate }}" appendTo="body" multiple="true"
                                formControlName="identifiersList" [addTag]="true"
                                (clear)="updateClinicMultipleIdentifiers()"
                                (change)="updateClinicMultipleIdentifiers()">
                            </ng-select>
                        </div>
                    </div>
                </div>

                <div style="display: flex; justify-content: flex-end;">
                    <button [disabled]="!viewClinicForm.valid" mat-raised-button color="primary"
                        (click)="updatedClinic()">{{ 'UPDATE' | translate }}</button>

                </div>
            </div>
        </div>
    </form>
</p-dialog>